export function initMatomo() {
    var _paq = window._paq = window._paq || [];
    /* tracker methods like "setCustomDimension" should be called before "trackPageView" */
    // trackPageView is pushed in front-end/src/main.js
    // _paq.push(['trackPageView']);
    _paq.push(['enableLinkTracking']);

    (function() {
        var u="https://oslomet.matomo.cloud/";
        _paq.push(['setTrackerUrl', u+'matomo.php']);
        _paq.push(['setSiteId', '6']);
        var d=document, g=d.createElement('script'), s=d.getElementsByTagName('script')[0];
        g.async=true; g.src='https://cdn.matomo.cloud/oslomet.matomo.cloud/matomo.js'; s.parentNode.insertBefore(g,s);
    })();
}
